import {
	coverageSourceTypeList,
	coverageSourceTypeCreate,
	coverageSourceTypeByID,
	coverageSourceTypeUpdate,
	coverageSourceTypeDestroy,
} from '@/services/agency/coverageSourceTypes.service'

export default {
	namespaced: true,
	state: {
		list: { data: [], meta: { pagination: { total: 0 } } },
		item: {},
		listStatus: 'init',
		saveStatus: 'init',
		deleteStatus: 'init',
	},
	getters: {
		getList(state) { return state.list },
		getItem(state) { return state.item },
		getListStatus(state) { return state.listStatus },
		getSaveStatus(state) { return state.saveStatus },
		getDeleteStatus(state) { return state.deleteStatus },
	},
	mutations: {
		SET_LIST(state, value) { state.list = value },
		SET_ITEM(state, value) { state.item = value },
		LIST_STATUS(state, value) { state.listStatus = value },
		SAVE_STATUS(state, value) { state.saveStatus = value },
		DELETE_STATUS(state, value) { state.deleteStatus = value },
	},
	actions: {
		async fetchList({ commit }, params) {
			commit('LIST_STATUS', 'pending')
			try {
				const { data } = await coverageSourceTypeList(params)
				commit('SET_LIST', data)
				commit('LIST_STATUS', 'init')
				return data
			} catch (error) {
				commit('LIST_STATUS', 'init')
				throw error
			}
		},
		async fetchByID({ commit }, id) {
			commit('LIST_STATUS', 'pending')
			try {
				const { data } = await coverageSourceTypeByID(id)
				commit('SET_ITEM', data.data)
				commit('LIST_STATUS', 'init')
				return data
			} catch (error) {
				commit('LIST_STATUS', 'init')
				throw error
			}
		},
		async save({ commit }, params) {
			commit('SAVE_STATUS', 'pending')
			try {
				const { data } = await coverageSourceTypeCreate(params)
				commit('SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SAVE_STATUS', 'init')
				throw error
			}
		},
		async update({ commit }, params) {
			commit('SAVE_STATUS', 'pending')
			try {
				const { data } = await coverageSourceTypeUpdate(params)
				commit('SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SAVE_STATUS', 'init')
				throw error
			}
		},
		async delete({ commit }, params) {
			commit('DELETE_STATUS', 'pending')
			try {
				const { data } = await coverageSourceTypeDestroy(params)
				commit('DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('DELETE_STATUS', 'init')
				throw error
			}
		},
	},
}
